export default "__VITE_ASSET__DcGG9YrM__"